import React, { useCallback, useEffect, useState } from 'react';
import {  useLocation, useNavigate } from 'react-router-dom';
import { api } from '../axiosInstance/axiosInstance';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthProvider';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const PricingPlans = () => {
  const [plans, setPlans] = useState<Array<any>>([]);
  const navigate = useNavigate();
  const { user } = useAuth()
  const { priceId } = useLocation()?.state || {};

  const listPlans = useCallback(() => {
    api.get('list-plans').then((response: any) => {
      setPlans(response.data);
      console.log(response);
    });
  }, []);

  const checkout = (priceId: string) => {
    console.log("Preço id ", priceId);
    if (user?.nick_name) {
      return navigate("/checkout", { state: { email: user?.email, priceId } });
    }
    navigate("/login", { state: { priceId } });
  };

  useEffect(() => {
    listPlans();
    if (priceId && user?.use_id) {
      navigate("/checkout", { state: { email: user?.email, priceId } });
    }
  }, []);

  console.log(plans);

  const downloadApp = () => { 
    
   navigate("/download-app"); 
  }

  return (
    <>
      <div className="sm:max-w-[85rem] w-full mb-14 px-4 py-10 sm:px-6 lg:px-8 lg:py-2 mx-auto min-h-screen">
        <div className="max-w-2xl mx-auto text-center mb-1">
          <h2 className="text-3xl leading-tight font-bold md:text-4xl md:leading-tight lg:text-3xl lg:leading-tight bg-clip-text bg-gradient-to-r from-cyan-600 to-fuchsia-700 text-transparent">
            Preços simples e transparentes
          </h2>
        </div>

        <div className="mt-5 flex flex-wrap  justify-center items-stretch gap-8">
          {plans.length > 0 ? (
            plans.filter((plan) => plan.active).sort((planA, planB) => planA.unit_amount - planB.unit_amount).map((plan) => (
              <div
                className={`relative   text-white flex flex-col border-2 ${plan.product.name === 'Plano Premium' ? 'border-pink-500 ' : 'border-pink-600'} text-center shadow-xl rounded-xl p-6 md:p-4 dark:border-pink-700 flex-grow w-full sm:w-9/12 md:max-w-xs`}
                key={plan.id}
                style={{ minHeight: '320px' }}
              >
                {plan.product.name === 'Plano Premium' && (
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/11971/11971680.png"
                    alt="Trophy"
                    className="absolute top-0 right-0 mt-2 mr-2 w-10 h-10"
                  />
                )}
                <h4 className="mt-2 font-medium text-3xl text-gray-800 dark:text-gray-200">
                  {
                    plan.product.name

                  }
                </h4>


                <span className="text-[17px] mt-5  text-white p-2 font-semibold bg-pink-600  rounded-md ">
                  {plan?.product?.description}
                </span>

                <span className="mt-5 font-bold text-5xl text-gray-800 dark:text-gray-200">
                  <span className="font-bold text-2xl">R$</span>
                  {(plan.unit_amount / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>

                <ul className="mt-4 space-y-2.5 flex-grow gap-1 flex flex-col">
                  {plan?.product?.marketing_features?.map((feature: any) => (
                    <li className="flex space-x-2 gap" key={feature.name}>

                      {feature.name.includes("Não") ? (
                        <CloseOutlined
                          className="flex-shrink-0 mt-0.5 size-4 text-red-600 dark:text-pink-500"
                        />
                      ) : (
                        <CheckOutlined
                          className="flex-shrink-0 mt-0.5 size-4 text-green-600 dark:text-pink-500"
                        />
                      )}


                      <span className="text-black text-[17px] text-justify dark:text-gray-400">
                        {feature?.name.trim()}
                      </span>


                    </li>
                  ))}
                </ul>


                <div className="flex items-end justify-center mt-auto">
                  {plan.product.name === "Plano Gratuito" ?

                    <button onClick={downloadApp}>
                      <span className="mt-4 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-pink-600 text-white hover:bg-pink-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                      Experimente já
                      </span>
                    </button>
                    :

                    <button onClick={() => checkout(plan.id)}>
                      <span className="mt-4 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-pink-600 text-white hover:bg-pink-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                        Assine agora!
                      </span>
                    </button>

                  }
                </div>
              </div>
            ))
          ) : (
            <div className="flex h-96 items-center justify-center w-full">
              <Spin size='large' />
            </div>
          )}
        </div>


      </div>
    </>
  );
};

export default PricingPlans;
